.default {
  box-sizing: border-box;
  width: 100%;
  max-width: none;
  height: auto;
  padding-block: var(--ism-spacing-m);
  padding-inline: var(--ism-spacing-m) calc(var(--ism-spacing-m) * 2 + 16px);
  margin: 0;
  font-family: inherit;
  font-size: var(--ism-font-size-body-l);
  line-height: 1.15;
  color: var(--ism-color-on-surface);
  appearance: none;
  cursor: pointer;
  background-color: var(--ism-color-surface);
  border: 1px solid var(--ism-color-outline);
  border-radius: var(--ism-radius-s);
}

.default:hover:enabled {
  border-color: var(--ism-color-on-surface);
}

.default:disabled {
  cursor: not-allowed;
  outline: var(--ism-color-disabled);
}

.default:focus {
  border-color: var(--ism-color-focused);
}

.default:focus-visible {
  outline-color: var(--ism-color-focused);
}

.default:invalid {
  color: var(--ism-color-error);
  background-color: var(--ism-color-error-container);
  border: 2px solid var(--ism-color-error);
}

.placeholder {
  composes: default;
  color: var(--ism-color-on-surface-variant);
}

.selectWrapper {
  position: relative;
}

.selectWrapper:has(select:disabled) {
  opacity: 0.5;
}

.chevronWrapper {
  position: absolute;
  inset-inline-end: var(--ism-spacing-m);
  top: 50%;
  height: 16px;
  color: var(--ism-color-on-surface);
  pointer-events: none;
  transform: translateY(-50%);
}

.errorMessage {
  display: flex;
  align-items: center;
  gap: var(--ism-spacing-2xs);
  margin-top: var(--ism-spacing-2xs);
  margin-bottom: 0;
  color: var(--ism-color-primary);
  font-family: inherit;
  font-size: var(--ism-font-size-body-s);
}
